export default function (props: any) {
    return (
        <svg
            width="48px"
            height="44px"
            viewBox="0 0 48 44"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="-Smart-Generator-(Dual-Fuel)" transform="translate(-1214.000000, -6074.000000)" fill="#FF0060">
                    <g id="编组-36" transform="translate(612.000000, 6074.000000)">
                        <g id="Noise-reduction" transform="translate(602.000000, 0.000000)">
                            <path
                                d="M16.8939034,24.933518 L28.5354415,31.7119547 L26.5648649,35.8596718 L31.8978855,44 L21.4702312,37.7868393 L24.1367872,34.0563619 L16.8939034,24.933518 Z M31.8978855,0 L26.5648649,8.1403282 L28.5354415,12.2880453 L16.8939034,19.066482 L24.1367872,9.94363814 L21.4702312,6.21316065 L31.8978855,0 Z"
                                id="形状结合"
                            ></path>
                            <path
                                d="M2.47788897,30.8643894 C1.10938868,30.8643894 1.13686838e-13,29.7965697 1.13686838e-13,28.4793474 L1.13686838e-13,14.7653558 C1.13686838e-13,13.4481335 1.10938868,12.3803138 2.47788897,12.3803138 L7.12393078,12.3803138 L14.7373047,5.6307486 C15.7438984,4.7383624 17.3114877,4.80037 18.2386135,5.76924644 C18.6599904,6.20959895 18.8939034,6.7863795 18.8939034,7.38505457 L18.8939034,35.8596487 C18.8939034,37.176871 17.7845147,38.2446907 16.4160144,38.2446907 C15.7940336,38.2446907 15.1947996,38.0195425 14.7373047,37.6139546 L7.12393078,30.8643894 L2.47788897,30.8643894 Z"
                                id="路径"
                            ></path>
                            <g id="编组-34" transform="translate(38.000000, 9.000000)">
                                <rect id="矩形备份-4" fillOpacity="0.3" x="0" y="6" width="10" height="3"></rect>
                                <rect id="矩形备份-15" fillOpacity="0.3" x="0" y="0" width="10" height="3"></rect>
                                <rect id="矩形备份-5" fillOpacity="0.3" x="0" y="12" width="10" height="3"></rect>
                                <rect id="矩形备份-6" x="0" y="18" width="10" height="3"></rect>
                                <rect id="矩形备份-14" x="0" y="24" width="10" height="3"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
